module.exports = __webpack_public_path__ + "static/Economyz-1cb3e86e2f23c35968626a126451c265.jpg";